let resolveAuthReady: (() => void) | null = null

export const authReady = new Promise<void>((resolve) => {
  resolveAuthReady = resolve
})

export const markAuthReady = (): void => {
  resolveAuthReady?.()
  resolveAuthReady = null
}
